import { TFunction } from 'next-i18next'
import { UsersAdmin } from 'src/core/models'

export interface SectionType {
  label1: string
  label2: string
  isVisible: boolean
  isLink?: boolean
  value?: string
}

export const leftSideSections = (t: TFunction, user: UsersAdmin): SectionType[] => [
  { label1: t('Validate.Name'), label2: `${user.first_name} ${user.last_name}`, isVisible: true },
  { label1: t('admin.Brokerage.CompanyName'), label2: user.userCompanyName, isVisible: user.user_type === 'business' },
  { label1: t('settings.Address'), label2: user.street, isVisible: true },
  { label1: t('settings.City'), label2: user.city, isVisible: true },
  { label1: t('Validate.State'), label2: user.state, isVisible: true },
  { label1: t('settings.Country'), label2: user.countryName, isVisible: true },
]

export const rigthSideSections = (t: TFunction, user: UsersAdmin): SectionType[] => [
  { label1: t('admin.Brokerage.Phone'), label2: user.phone, isLink: false, isVisible: true },
  { label1: t('Validate.ReasonJoined'), label2: user.reason_joined, isLink: false, isVisible: true },
  { label1: t('Validate.IdentityDocument'), label2: `${user.aws_url}${user.vatNumberDocument}`,
    isLink: true, isVisible: true, value: user.vatNumberDocument },

  { label1: t('Validate.Powerofattornet'), label2: `${user.aws_url}${user.powerOf_attorneyDocument}`,
    isLink: true, isVisible: true, value: user.powerOf_attorneyDocument },

  { label1: t('Validate.CompanyDocumentation'), label2: `${user.aws_url}${user.companyRepresentativeIdDocument}`,
    isLink: true, isVisible: true, value: user.companyRepresentativeIdDocument },
]
